var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailBot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 17,
    viewBox: "0 0 23 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4834 2.74438L10.8969 7.8768C11.3249 8.17315 11.8919 8.17315 12.3199 7.8768L19.7334 2.74438M4.1084 15.8694H19.1084C20.4891 15.8694 21.6084 14.7501 21.6084 13.3694V3.36938C21.6084 1.98867 20.4891 0.869385 19.1084 0.869385H4.1084C2.72769 0.869385 1.6084 1.98867 1.6084 3.36939V13.3694C1.6084 14.7501 2.72769 15.8694 4.1084 15.8694Z",
    stroke: "#825DFC",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailBot);
export default __webpack_public_path__ + "static/media/email-bot.e285c0a6f591c43a9e3904d446553964.svg";
export { ForwardRef as ReactComponent };